module.exports = __webpack_public_path__ + "static/media/tutorial-dashboard-step3.7e96e934.png";